import { Component, OnInit } from '@angular/core';
import { Subscription, map } from 'rxjs';

import { ProdutoService } from 'src/app/core/services/http/produto.service';
import { TamanhoService } from 'src/app/core/services/http/tamanho.service';
import { ProdutoCategoriaModel } from 'src/app/shared/models/produto-familia.model';
import { ProdutoModel } from 'src/app/shared/models/produto.model';
import { TamanhoResponseModel } from 'src/app/shared/models/tamanho.model';

@Component({
  selector: 'app-aba-pizza-cadastro-produtos',
  templateUrl: './aba-pizza-cadastro-produtos.component.html',
  styleUrls: ['./aba-pizza-cadastro-produtos.component.scss'],
})
export class AbaPizzaCadastroProdutosComponent implements OnInit {
  private _subs: Subscription[] = [];

  public categorias: ProdutoCategoriaModel[] = [];
  public produtos: ProdutoModel[] = [];
  public sabores: ProdutoModel[] = [];
  public tamanhosPizza: TamanhoResponseModel[] = [];

  constructor(
    private _produtoService: ProdutoService,
    private _tamanhoService: TamanhoService
  ) { }

  public getProdutosPorSabor(sabor: ProdutoModel) {
    return this.produtos.filter(produtoFiltrado => {
      const categoria = this.categorias.find(l => l.codigo === produtoFiltrado.codCategoria);
      const nomeParaLimpar = `PIZZA ${categoria.nome}`;

      return produtoFiltrado.nome.replace(nomeParaLimpar, '').trim() === sabor.nome;
    });
  }

  public ngOnInit() {
    const sub1 = this._produtoService
      .getSubGruposPorCodigoFamilia(3) // 3 = Pizza
      .subscribe(res => {
        if (!res.success) return;

        this.categorias = res.data;

        this.produtos = this.categorias.flatMap(l => l.produtos);

        this._prepararCategorias();
      });

    const sub2 = this._tamanhoService
      .getTamanhosPizza()
      .subscribe(res => {
        if (!res.success) return;

        this.tamanhosPizza = res.data;
      });

    this._subs.push(sub1, sub2);
  }

  private _prepararCategorias() {
    const primeiraCategoria = this.categorias[0];

    const nomeParaLimpar = `PIZZA ${primeiraCategoria.nome}`;

    primeiraCategoria.produtos.forEach(produto => this.sabores.push(Object.assign({}, produto)));

    this.sabores.forEach(sabor => sabor.nome = sabor.nome.replace(nomeParaLimpar, '').trim());
  }
}
